<template>
  <div>
    <nav>
      <button
        v-for="(button, index) in chartConfigExtractor"
        :key="index"
        @click="setConfigurationComponent(button.option)"
        :class="{ active: option === button.option }"
      >
        {{ button.label }}
      </button>
    </nav>

    <transition mode="out-in">
      <component
        :is="getChartConfigurationComponent()"
        :id="`${question_result.code}-${option}`"
        :question_result="question_result"
        :groupCode="groupCode"
        :defaultTheme="defaultTheme"
      />
    </transition>
  </div>
</template>

<script>
import ConfigType from '../ConfigItems/Types'
import ConfigColors from '../ConfigItems/Colors'
import ConfigPercent from '../ConfigItems/Percent'

import * as translationConfig from '../configs.translations'

const { default: translations, ...translationKeys } = translationConfig

export default {
  name: 'ChartConfig',

  components: {
    ConfigType,
    ConfigColors,
    ConfigPercent,
  },

  props: {
    question_result: {
      required: true,
      type: Object,
    },

    groupCode: {
      required: true,
    },

    defaultTheme: {
      required: true,
    },
  },

  data() {
    return {
      CONFIG_OPTION: {
        TYPE: 'type',
        COLOR: 'color',
        PERCENTAGE: 'percentage',
      },

      option: null,

      translations,
      ...translationKeys,
    }
  },

  computed: {
    chartConfigExtractor() {
      const chartConfigExtractor = [
        {
          label: this.parseTranslation(this.CHART_TYPE),
          option: this.CONFIG_OPTION.TYPE,
        },

        {
          label: this.parseTranslation(this.COLORS),
          option: this.CONFIG_OPTION.COLOR,
        },

        {
          label: this.parseTranslation(this.DATA_TYPE),
          option: this.CONFIG_OPTION.PERCENTAGE,
        },
      ]

      return chartConfigExtractor
    },
  },

  methods: {
    getChartConfigurationComponent() {
      switch (this.option) {
        case this.CONFIG_OPTION.TYPE:
          return 'ConfigType'
        case this.CONFIG_OPTION.COLOR:
          return 'ConfigColors'
        case this.CONFIG_OPTION.PERCENTAGE:
          return 'ConfigPercent'
        default:
          throw new Error(`${this.option} is not a valid Stat type`)
      }
    },

    setConfigurationComponent(option) {
      if (option) {
        this.option = option
        return
      }

      this.option = this.CONFIG_OPTION.TYPE
    },
  },

  created() {
    this.setConfigurationComponent()
  },
}
</script>

<style lang="scss" scoped></style>
